import React, { useEffect, useState } from 'react';
import { FiClock, FiUser, FiCalendar, FiCheckCircle, FiTrendingUp, FiBarChart2, FiShoppingCart, FiDollarSign, FiPercent, FiMoreVertical, FiSearch } from 'react-icons/fi';
import { BsCreditCard, BsCreditCard2Front } from 'react-icons/bs';
import Header from '../../../components/Header';
import { useUser } from '../../../contexts/userContext';
import api from '../../../services/api';
import './style.css';

function MarketingPage() {
  const { user } = useUser();
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [taxaConversao, setTaxaConversao] = useState(0);
  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [estatisticas, setEstatisticas] = useState({
    totalPedidos: { valor: 155000, crescimento: 22 },
    totalVendas: { valor: 13400, crescimento: 38 },
    lucroTotal: { valor: 88500, crescimento: -18 },
    crescimentoTotal: { valor: 27900, percentual: 16 }
  });

  useEffect(() => {
    const hoje = new Date();
    const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

    setDataInicial(primeiroDiaMes.toISOString().split('T')[0]);
    setDataFinal(ultimoDiaMes.toISOString().split('T')[0]);
  }, []);

  useEffect(() => {
    if (dataInicial && dataFinal) {
      buscarDados();
    }
  }, [dataInicial, dataFinal]);

  const buscarDados = async () => {
    setLoading(true);
    try {
      // Buscar tempo de resposta
      const responseTempos = await api.get('/marketing/tempo-resposta', {
        params: { dataInicial, dataFinal }
      });
      setDados(responseTempos.data);

      // Buscar taxa de conversão
      const responseTaxa = await api.get('/marketing/taxa-conversao', {
        params: {
          dataInicial,
          dataFinal,
          empresaId: user.empresa_id
        }
      });
      
      // Garantir que a taxa de conversão seja um número
      const taxa = responseTaxa.data?.taxa_conversao_percentual;
      console.log('Taxa recebida:', taxa); // Debug
      const taxaNumero = parseFloat(taxa);
      setTaxaConversao(isNaN(taxaNumero) ? 0 : taxaNumero);

      // Aqui você adicionaria as chamadas para buscar os dados das estatísticas
      // Por enquanto vou manter os dados mockados
      setEstatisticas({
        totalPedidos: { valor: 155000, crescimento: 22 },
        totalVendas: { valor: 13400, crescimento: 38 },
        lucroTotal: { valor: 88500, crescimento: -18 },
        crescimentoTotal: { valor: 27900, percentual: 16 }
      });
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      setDados([]);
      setTaxaConversao(0);
    } finally {
      setLoading(false);
    }
  };

  // Função para formatar a taxa de conversão
  const formatarTaxaConversao = (taxa) => {
    if (typeof taxa !== 'number' || isNaN(taxa)) return '0,00';
    return taxa.toFixed(2).replace('.', ',');
  };

  return (
    <div className="marketing-page">
      <Header />
      <div className="marketing-page-title">
        <h1>Marketing</h1>
        <div className="period-selector">
          <div className="period-selector-dates">
            <div className="period-selector-date">
              <label>De:</label>
              <input
                type="date"
                value={dataInicial}
                onChange={(e) => setDataInicial(e.target.value)}
                max={dataFinal}
              />
            </div>
            <div className="period-selector-date">
              <label>Até:</label>
              <input
                type="date"
                value={dataFinal}
                onChange={(e) => setDataFinal(e.target.value)}
                min={dataInicial}
              />
            </div>
          </div>
          <button onClick={buscarDados}>
            <FiSearch />
            Buscar
          </button>
        </div>
      </div>
      <div className="marketing-page-content">
        <div className="marketing-stats-cards">
          <div className="marketing-stat-card">
            <div className="marketing-stat-card-header">
              <FiShoppingCart />
              <span>Total de Pedidos</span>
            </div>
            <div className="marketing-stat-card-value">
              {estatisticas.totalPedidos.valor.toLocaleString()}k
            </div>
            <div className="marketing-stat-card-trend">
              <FiTrendingUp />
              <span className="trend-up">+{estatisticas.totalPedidos.crescimento}%</span>
              <span>Last 4 Month</span>
            </div>
          </div>

          <div className="marketing-stat-card">
            <div className="marketing-stat-card-header">
              <FiDollarSign />
              <span>Total de Vendas</span>
            </div>
            <div className="marketing-stat-card-value">
              ${estatisticas.totalVendas.valor.toLocaleString()}k
            </div>
            <div className="marketing-stat-card-trend">
              <FiTrendingUp />
              <span className="trend-up">+{estatisticas.totalVendas.crescimento}%</span>
              <span>Last Six Month</span>
            </div>
          </div>

          <div className="marketing-stat-card">
            <div className="marketing-stat-card-header">
              <FiDollarSign />
              <span>Lucro Total</span>
            </div>
            <div className="marketing-stat-card-value">
              ${estatisticas.lucroTotal.valor.toLocaleString()}k
            </div>
            <div className="marketing-stat-card-trend">
              <FiTrendingUp />
              <span className="trend-down">{estatisticas.lucroTotal.crescimento}%</span>
            </div>
          </div>

          <div className="marketing-stat-card">
            <div className="marketing-stat-card-header">
              <FiPercent />
              <span>Crescimento Total</span>
            </div>
            <div className="marketing-stat-card-value">
              ${estatisticas.crescimentoTotal.valor.toLocaleString()}k
            </div>
            <div className="marketing-stat-card-trend">
              <div style={{ width: '40px', height: '40px', position: 'relative' }}>
                <svg viewBox="0 0 36 36" style={{ transform: 'rotate(-90deg)' }}>
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#eee"
                    strokeWidth="3"
                  />
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#28a745"
                    strokeWidth="3"
                    strokeDasharray={`${estatisticas.crescimentoTotal.percentual}, 100`}
                  />
                </svg>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                  {estatisticas.crescimentoTotal.percentual}%
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="marketing-page-taxa-conversao-card">
          <h2><FiTrendingUp /> Taxa de Conversão</h2>
          <div className="marketing-page-taxa-conversao-valor">
            <span>{formatarTaxaConversao(taxaConversao)}%</span>
            <p>Taxa de conversão no período selecionado</p>
          </div>
        </div>

        <div className="marketing-page-table">
          <h2>
            Tempo de Resposta
            <FiMoreVertical style={{ cursor: 'pointer' }} />
          </h2>
          {loading ? (
            <div className="marketing-page-loading-container">
              <p className="marketing-page-loading-text">Carregando dados...</p>
            </div>
          ) : (
            <>
              {dados.slice(0, 6).map((item) => (
                <div key={item.card_id} className="response-item">
                  <div className="response-icon">
                    <BsCreditCard2Front size={24} color="#007bff" />
                  </div>
                  <div className="response-info">
                    <div className="response-card-number">#{item.card_id}</div>
                    <div className="response-card-type">{item.cliente_nome}</div>
                  </div>
                  <div className="response-date">
                    {item.created_at ? new Date(item.created_at).toLocaleDateString('pt-BR', { 
                      day: '2-digit',
                      month: 'short'
                    }) : '-'}
                  </div>
                  <div>
                    <div className="response-time">
                      {item.total_horas_uteis ? `-${item.total_horas_uteis.toFixed(1)}h` : '-'}
                    </div>
                    <div className="response-total">
                      {item.em_contato_at ? `Contato em ${new Date(item.em_contato_at).toLocaleTimeString('pt-BR', {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}` : 'Pendente'}
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MarketingPage; 